import { useEffect } from 'react'

export const useScrollLock = () => {
  const handleScrollLock = () => {
    document.body.classList.add('scrolllock')
  }

  const handleScrollUnlock = () => {
    document.body.classList.remove('scrolllock')
  }

  useEffect(() => {
    return () => {
      handleScrollUnlock()
    }
  }, [])

  return {
    handleScrollLock,
    handleScrollUnlock
  }
}
